/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {withDLSTheme} from '../../theme/withDLSTheme';
import {TertiaryIconButton as CurrentTertiaryIconButton} from './current/TertiaryIconButton';
import {TertiaryButton as LegacyTertiaryButton} from './legacy/TertiaryButton';

type TertiaryButtonComponentProps = React.ComponentProps<typeof CurrentTertiaryIconButton>;

// This is essential if a client imports the `TertiaryButton` component using
// `import {TertiaryButton} from ‘./TertiaryButton’;`
export const TertiaryButton = withDLSTheme<TertiaryButtonComponentProps>(
  LegacyTertiaryButton as unknown as React.ComponentType<TertiaryButtonComponentProps>,
  CurrentTertiaryIconButton
);

export default TertiaryButton;
